import React, { Component } from "react";
import { Grid } from "@mui/material";

export const securityQuestions = [
  "What was your childhood nickname?",
  "What is the first name of your favorite childhood friend?",
  "What was the name of your first stuffed animal?",
  "In what city does your nearest sibling live?",
  "What is your oldest cousin's first and last name?",
  "What is the first name of the person you first kissed?",
  "What was the name of your elementary / primary school?",
  "What is your oldest sibling's middle name?",
];

class SecurityQuestion extends Component {
  state = {};

  render() {
    const { setQuestion, setAnswer } = this.props;

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <select className="bbe-select" onChange={setQuestion}>
            {securityQuestions.map((value, index) => (
              <option value={value}>{value}</option>
            ))}
          </select>
        </Grid>
        <Grid item xs={12}>
          <input
            type="text"
            name="answer"
            className="textbox logintext"
            onChange={setAnswer}
          />
        </Grid>
        <Grid item xs={12}>
          <p>Answer is case insensitive</p>
        </Grid>
      </Grid>
    );
  }
}

export default SecurityQuestion;
